export default class NotLoggedInError extends Error {}
